import { ViewSupport411Container } from "../../../containers/SupportSystem/ViewReports/ViewSupport411Container"
export function ViewSupport411Page() {
    return (
        <ViewSupport411Container />
    )
}